import { render, staticRenderFns } from "./Quiz_Sample.vue?vue&type=template&id=c23a042a&"
import script from "./Quiz_Sample.vue?vue&type=script&lang=js&"
export * from "./Quiz_Sample.vue?vue&type=script&lang=js&"
import style0 from "./Quiz_Sample.vue?vue&type=style&index=0&id=c23a042a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports